import { Fragment, type ReactNode } from "react";

import { t } from "@/lib/i18n";
/** Suchbegriffe im Text markieren (ohne Regex aus Nutzereingaben) */
export function Highlight({ text, needles }: { text: string; needles: string[] }) {
  if (!needles.length || !text) return <>{t(text)}</>;
  const lower = text.toLowerCase();
  const marks: [number, number][] = [];
  for (const n of needles) {
    if (!n) continue;
    for (let i = lower.indexOf(n); i >= 0; i = lower.indexOf(n, i + n.length)) marks.push([i, i + n.length]);
  }
  if (!marks.length) return <>{t(text)}</>;
  marks.sort((a, b) => a[0] - b[0]);
  const out: ReactNode[] = [];
  let pos = 0;
  for (const [s, e] of marks) {
    if (e <= pos) continue;
    const start = Math.max(s, pos);
    if (start > pos) out.push(text.slice(pos, start));
    out.push(<mark key={start} className="bg-coral/20 text-fg rounded-[3px] px-px">{text.slice(start, e)}</mark>);
    pos = e;
  }
  out.push(text.slice(pos));
  return <>{out.map((x, i) => <Fragment key={i}>{x}</Fragment>)}</>;
}

